import { useRef as $, useState as L, useMemo as N } from "react";
import { autoUpdate as X, computePosition as Y, arrow as q, flip as I, offset as K, shift as Q, size as T } from "../../../@floating-ui/dom/dist/floating-ui.dom.js";
import { useEvent as Z, useForceUpdate as _, useSafeLayoutEffect as ee } from "../../../ariakit-react-utils/esm/hooks.js";
import { flushSync as te } from "react-dom";
import { useDialogState as ne } from "../dialog/dialog-state.js";
const b = {
  arrow: q,
  flip: I,
  offset: K,
  shift: Q,
  size: T
};
function j(t, n, s, e) {
  if (t === void 0 && (t = 0), n === void 0 && (n = 0), s === void 0 && (s = 0), e === void 0 && (e = 0), typeof DOMRect == "function")
    return new DOMRect(t, n, s, e);
  const r = {
    x: t,
    y: n,
    width: s,
    height: e,
    top: n,
    right: t + s,
    bottom: n + e,
    left: t
  };
  return {
    ...r,
    toJSON: () => r
  };
}
function oe(t) {
  if (!t) return j();
  const {
    x: n,
    y: s,
    width: e,
    height: r
  } = t;
  return j(n, s, e, r);
}
function re(t, n) {
  return {
    contextElement: t.current || void 0,
    getBoundingClientRect: () => {
      const e = t.current, r = n(e);
      return r || !e ? oe(r) : e.getBoundingClientRect();
    }
  };
}
function se(t) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(t);
}
function de(t) {
  let {
    placement: n = "bottom",
    fixed: s = !1,
    gutter: e,
    flip: r = !0,
    shift: u = 0,
    slide: g = !0,
    overlap: d = !1,
    sameWidth: h = !1,
    fitViewport: x = !1,
    arrowPadding: v = 4,
    overflowPadding: l = 8,
    renderCallback: y,
    ...A
  } = t === void 0 ? {} : t;
  const f = ne(A), G = (o) => (o == null ? void 0 : o.getBoundingClientRect()) || null, R = Z(A.getAnchorRect || G), M = $(null), O = $(null), E = $(null), [C, D] = L(n), [U, S] = _();
  return ee(() => {
    var B;
    if (!((B = f.contentElement) != null && B.isConnected)) return;
    const o = O.current;
    if (!o) return;
    const P = re(M, R), c = E.current, k = ((c == null ? void 0 : c.clientHeight) || 0) / 2, z = typeof e == "number" ? e + k : e ?? k;
    o.style.setProperty("--popover-overflow-padding", `${l}px`);
    const W = () => X(P, o, async () => {
      if (!f.mounted) return;
      const w = [
        // https://floating-ui.com/docs/offset
        b.offset((i) => {
          let {
            placement: a
          } = i;
          return {
            crossAxis: !!a.split("-")[1] ? void 0 : u,
            mainAxis: z,
            alignmentAxis: u
          };
        })
      ];
      if (r !== !1) {
        const i = typeof r == "string" ? r.split(" ") : void 0;
        if (i !== void 0 && !i.every(se))
          throw new Error("`flip` expects a spaced-delimited list of placements");
        w.push(b.flip({
          padding: l,
          fallbackPlacements: i
        }));
      }
      (g || d) && w.push(b.shift({
        mainAxis: g,
        crossAxis: d,
        padding: l
      })), w.push(b.size({
        padding: l,
        apply(i) {
          let {
            availableWidth: a,
            availableHeight: p,
            rects: J
          } = i;
          const H = Math.round(J.reference.width);
          a = Math.floor(a), p = Math.floor(p), o.style.setProperty("--popover-anchor-width", `${H}px`), o.style.setProperty("--popover-available-width", `${a}px`), o.style.setProperty("--popover-available-height", `${p}px`), h && (o.style.width = `${H}px`), x && (o.style.maxWidth = `${a}px`, o.style.maxHeight = `${p}px`);
        }
      })), c && w.push(b.arrow({
        element: c,
        padding: v
      }));
      const m = await Y(P, o, {
        placement: n,
        strategy: s ? "fixed" : "absolute",
        middleware: w
      });
      te(() => {
        D(m.placement);
      });
      const V = Math.round(m.x), F = Math.round(m.y);
      if (Object.assign(o.style, {
        top: "0",
        left: "0",
        transform: `translate3d(${V}px, ${F}px, 0)`
      }), c && m.middlewareData.arrow) {
        const {
          x: i,
          y: a
        } = m.middlewareData.arrow, p = m.placement.split("-")[0];
        Object.assign(c.style, {
          left: i != null ? `${i}px` : "",
          top: a != null ? `${a}px` : "",
          [p]: "100%"
        });
      }
    }, {
      // JSDOM doesn't support ResizeObserver
      elementResize: typeof ResizeObserver == "function"
    });
    return y ? y({
      mounted: f.mounted,
      placement: n,
      fixed: s,
      gutter: z,
      shift: u,
      overlap: d,
      flip: r,
      sameWidth: h,
      fitViewport: x,
      arrowPadding: v,
      overflowPadding: l,
      popover: o,
      anchor: P,
      arrow: c,
      setPlacement: D,
      defaultRenderCallback: W
    }) : W();
  }, [U, f.contentElement, R, e, f.mounted, u, d, r, l, g, h, x, v, n, s, y]), N(() => ({
    ...f,
    getAnchorRect: R,
    anchorRef: M,
    popoverRef: O,
    arrowRef: E,
    currentPlacement: C,
    placement: n,
    fixed: s,
    gutter: e,
    shift: u,
    flip: r,
    slide: g,
    overlap: d,
    sameWidth: h,
    fitViewport: x,
    arrowPadding: v,
    overflowPadding: l,
    render: S,
    renderCallback: y
  }), [f, R, C, n, s, e, u, r, g, d, h, x, v, l, S, y]);
}
export {
  de as usePopoverState
};
//# sourceMappingURL=popover-state.js.map
